import { PublicMainContainerProps } from './props'
import { AppBar, Box, Button, IconButton, Toolbar, useMediaQuery, useTheme } from '@mui/material'
import { DeltaCoreXLogoWhite } from '../../../assets/icons'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link, useNavigate } from 'react-router'
import links from '../../../routes/links'
import authStore from '../../../store/authStore'
import AuthProvider from '../../../hooks/Providers/Auth'
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled'
import LoginIcon from '@mui/icons-material/Login'
import LogoutIcon from '@mui/icons-material/Logout'
import AuthService from '../../../services/auth'
import { Fragment } from 'react/jsx-runtime'
import PERMISSIONS from '../../../private/permissions'

export default function PublicMainContainer(props: PublicMainContainerProps) {
  const navigate = useNavigate()
  const user = authStore(state => state.user)
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <AuthProvider>
      <AppBar variant='elevation' position='sticky'>
        <Toolbar sx={{ gap: 2, py: 2 }}>
          {props.showBackButton ? (
            <IconButton
              size='large'
              edge='start'
              color='inherit'
              aria-label='back'
              onClick={() => navigate(props.backLink ?? links.public.home())}
            >
              <ArrowBackIcon />
            </IconButton>
          ) : null}
          <Box sx={{ flexGrow: 1 }}>
            <DeltaCoreXLogoWhite width={110} height={48} />
          </Box>

          {!user ? (
            <Link to={links.auth.login({})} style={{ textDecoration: 'none', color: 'inherit' }}>
              <Button variant='contained' color='secondary' startIcon={<LoginIcon />}>
                Login
              </Button>
            </Link>
          ) : (
            <Fragment>
              {PERMISSIONS.getBackofficerEmails().includes(user.email as string) ? (
                <Link to={links.admin.dashboard()} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Button variant='outlined' color='secondary' startIcon={upMd ? <DomainDisabledIcon /> : undefined}>
                    {upMd ? 'Backoffice' : <DomainDisabledIcon />}
                  </Button>
                </Link>
              ) : null}
              <Button
                variant='outlined'
                color='secondary'
                startIcon={<LogoutIcon />}
                onClick={AuthService.firebaseLogout}
              >
                Logout
              </Button>
            </Fragment>
          )}
        </Toolbar>
      </AppBar>
      <Box sx={props.wrapperBoxSx}>{props.children}</Box>
    </AuthProvider>
  )
}
